import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap';
import DOMPurify from "dompurify";
import ArrowButton from '../common/button-arrow';

class UpsellPopup extends Component {
  render() {
    const { upsell_popup } = this.props;

    return (
      <Modal
        show={true}
        container={this}
        dialogClassName="modal-60w"
      >
        <Modal.Body>
          <div className="upsell-flex-container">
            <div className="upsell-title">{upsell_popup.title}</div>
            <div className="upsell-content-flex-container">
              <div className="upsell-image-flex-container"><img className="upsell-image" src={upsell_popup.image}/></div>
              <div className="upsell-wording-flex-container">
                <div
                  className="upsell-wording-container"
                  dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(upsell_popup.wording)}} />
                <ArrowButton
                  color="grey"
                  submit={false}
                  arrow={false}
                  onClick={() => this.props.onClose(true)}>{this.props.closeLabel}
                </ArrowButton>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

UpsellPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  upsell_popup: PropTypes.any,
  closeLabel: PropTypes.string,
};

UpsellPopup.defaultProps = {
  closeLabel: 'Close',
};

export default UpsellPopup;



// WEBPACK FOOTER //
// ./src/components/new-order/upsell-popup.jsx